// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1___7cffc67f6fe11aa4abb","cls2":"ConfirmationModal-cls2__e5465d7003c5dd86211a ConfirmationModal-cls1___7cffc67f6fe11aa4abb"};